module.exports = __webpack_public_path__ + "static/img/filter-scheduled.9b20f8e.svg";